import RenderBlocks from '@lib/cms/renderBlocks';
import { validateSchemaJSON } from '@lib/utils';

import Layout from '@layout/index';

const FlexiblePage = ({ children, data, preview, specializedPageSchema }) => {
  // Validate CMS schema from data
  const cmsSchema = data?.schema ? validateSchemaJSON(data.schema, `flex/${data.slug}`) : null;

  return (
    <Layout
      preview={preview}
      meta={{
        description: data?.metaDescription,
        image: data?.metaImage,
        title: data?.metaTitle
      }}
      specializedPageSchema={specializedPageSchema}
      cmsSchema={cmsSchema}
    >
      {data?.blocksCollection &&
        RenderBlocks(data.blocksCollection.items, { markFirstBlockAsH1: true })}
      {children}
    </Layout>
  );
};

export default FlexiblePage;
